"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const EditorTagContext = createContext(null);
function useEditorTagRenderer() {
  const renderer = useContext(EditorTagContext);
  if (!renderer) {
    throw new Error("useEditorTagRenderer must be used within EditorTagContextProvider");
  }
  return renderer;
}

export { EditorTagContext, useEditorTagRenderer };
